"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon = _interopRequireDefault(require("../icon/icon.js"));
require("./button.css");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} // Importing icons
// Button component
function Button(props) {
  //Defining variables
  var disabled = props.disabled ? true : false,
    classList = ['default'],
    content = [],
    id = props.id ? props.id : '',
    name = props.name ? props.name : '',
    inputType = false,
    type = '';
  if (props.className) classList.push(props.className);
  if (props.disabled) classList.push('disabled');
  if (props.small) classList.push('small');

  /*
  We are pushing elements to array
  to prevent appearing empty spans
  if icon/label is empty
  */

  // If icon exists - adding proper classes and pushing icon to content
  if (props.icon) {
    var iconClass = props.label ? 'has-icon' : props.rounded ? 'rounded' : 'icon';
    classList.push(iconClass);
    if (!props.loading || props.label) content.push( /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      img: props.icon,
      key: 'button_icon_' + props.keyValue
    }));
  }

  // Adding facebook icon
  if (props.facebook) {
    content.push( /*#__PURE__*/_react["default"].createElement("img", {
      className: "facebook-logo-img",
      src: "/images/facebook-icon.svg",
      alt: "facebook Logo",
      style: {
        width: "18px",
        height: "18px",
        marginRight: "8px"
      },
      key: "facebook_icon_" + props.keyValue
    }));
  }

  // Adding google icon
  if (props.google) {
    content.push( /*#__PURE__*/_react["default"].createElement("img", {
      className: "google-logo-img",
      src: "/images/google-icon.svg",
      alt: "google Logo",
      style: {
        width: "18px",
        height: "18px",
        marginRight: "8px"
      },
      key: "google_icon_" + props.keyValue
    }));
  }

  // Pushing label to content if exist
  if (props.label) content.push( /*#__PURE__*/_react["default"].createElement("span", {
    className: "label",
    key: "label_" + props.keyValue
  }, props.label));

  // Pushing loading
  var key = "loader_" + props.keyValue;
  if (props.loading && props.primary && props.danger) content.push( /*#__PURE__*/_react["default"].createElement("img", _extends({
    src: require('../assets/images/loader_white.svg')
  }, key)));else if (props.loading && props.danger) content.push( /*#__PURE__*/_react["default"].createElement("img", _extends({
    src: require('../assets/images/loader_red.svg')
  }, key)));else if (props.loading) content.push( /*#__PURE__*/_react["default"].createElement("img", _extends({
    src: require('../assets/images/loader.svg')
  }, key)));
  if (props.loading) classList.push('loading');

  // View types
  if (props.danger) classList.push('danger');
  if (props.wide) classList.push('wide');

  // Defining type of button if not default
  if (props.primary) {
    type = 'primary';
    classList.push('primary');
  }

  // supporting 'link' prop that was in previous versions and is same as 'text'
  if (props.link || props.text) {
    type = 'text';
    classList.push('text');
  }

  // Joining classes to string
  classList = classList.join(' ');
  if (props.file) inputType = 'file';
  if (props.submit) inputType = 'submit';
  if (props.reset) inputType = 'reset';

  // Passing handlers to component
  var handlers = {};
  for (var prop in props) {
    if (typeof props[prop] === "function") Object.assign(handlers, _defineProperty({}, prop, props[prop]));
  }

  // In case if children defined
  if (content.length < 1) content = props.children;

  // Defining component content
  var component = !inputType ? /*#__PURE__*/_react["default"].createElement("button", _extends({
    id: id,
    key: props.keyValue || "button_" + id,
    type: type,
    style: props.style,
    className: classList,
    disabled: disabled
  }, handlers), content) : /*#__PURE__*/_react["default"].createElement("button", _extends({
    id: props.buttonId,
    key: props.buttonKey || 'hidden_input_button_' + props.buttonId,
    type: type,
    className: classList,
    style: props.style,
    disabled: disabled
  }, handlers, {
    onClick: function onClick(e) {
      return openDialog(e);
    }
  }), content, /*#__PURE__*/_react["default"].createElement("input", {
    id: id,
    key: props.keyValue || "input_" + id,
    hidden: true,
    onChange: props.onChange,
    className: "hiddenInput",
    type: inputType,
    name: inputType
  }));
  return component;
}

// Activating form elements
function openDialog(e) {
  var elem = e.target;
  while (elem.tagName !== 'BUTTON') {
    elem = elem.parentNode;
  }
  elem.lastChild.click();
}
var _default = exports["default"] = Button;